/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductSpecsQueryResponse, GetShowProductSpecsPathParams, GetShowProductSpecsQueryParams, GetShowProductSpecs404 } from "../../models/GetShowProductSpecs";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductSpecsUrl({ code }: { code: GetShowProductSpecsPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/specifications` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/specifications}
 */
export async function getShowProductSpecs({ code, params }: { code: GetShowProductSpecsPathParams["code"]; params: GetShowProductSpecsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductSpecsQueryResponse, ResponseErrorConfig<GetShowProductSpecs404>, unknown>({ method : "GET", url : getGetShowProductSpecsUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}